import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from '/node_modules/swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

// import Swiper and modules styles


$(function () {

    $.fn.sliderAcfTrust = function () {

        new Swiper(this[0], {
            slidesPerView: 'auto',
            spaceBetween: 25,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            },
        });
    
    };

});